import GenActions from './GenActions';
import GenRootStore from './GenRootStore'
import GenReactions from './GenReactions';
// /**
//  * 基于YNF Store，扩展开发领域、行业的业务stores
//  * 定义：Domain Store
//  */
// export function ExtendStore(rootStore: object){
//   return GenStores(rootStore)
// }

/**
 * 针对YNF common actions 的扩展
 * 绑定和加载领域、行业自定义的 action
 * 定义：明确的、静态的 action 动作
 */
export function ExtendAction (rootStore: object) {
  return GenActions(rootStore);
}
/**
 * 针对 YNF Reaction 的扩展
 * 绑定和加载领域、行业自定义的 reactions
 * 定义：reactions track 具体的状态值，接收指定的 store 并按明确的逻辑更新 domain store 中的数据，
 * reactions 也可以调用 rootStore 中的 API、Action 等
 */
export function ExtendReaction (rootStore: object) {
  return GenReactions(rootStore)
}

/**
 * ExtendRootStore
 * 针对全局通用的 api、utils、pagestore等扩展
 * 也可以直接定义具体的业务扩展逻辑
 *
 */
export function ExtendRootStore (rootStore: object) {
  return GenRootStore(rootStore)
}
